<template>
  <SemanticQueries v-slot="{ queries, findSemanticQuery }">
    <section>
      <h1
        class="x-text4 x-my-64 x-h-[75px] x-content-center x-bg-neutral-25 x-text-center x-font-main x-text-lead-75"
      >
        {{ $t('semanticQueries.title', { query: x.query.search }) }}
      </h1>
      <QueryPreviewList
        v-slot="{ queryPreviewInfo: { query }, results, totalResults }"
        :queries-preview-info="queries.map((q: string) => ({ query: q }))"
        class="x-flex x-flex-col x-gap-64"
        data-wysiwyg="query-previews"
      >
        <CustomSlidingPanel>
          <template #header>
            <SemanticQuery
              :suggestion="findSemanticQuery(query)"
              class="x-button x-button-neutral x-button-tight max-desktop:x-px-16"
            >
              {{ query }}
              ({{ totalResults }})
              <ArrowRightIcon class="x-icon-lg" />
            </SemanticQuery>
          </template>
          <DisplayClickProvider result-feature="semantic_recommendations">
            <div class="x-flex x-gap-16 x-pt-16 max-desktop:x-px-16">
              <Result
                v-for="result in results.slice(0, resultsPerCarousel)"
                :key="result.id"
                :result="result"
                class="x-w-[calc(38vw-16px)] desktop:x-w-[216px]"
              />
            </div>
          </DisplayClickProvider>
        </CustomSlidingPanel>
      </QueryPreviewList>
    </section>
  </SemanticQueries>
</template>

<script setup lang="ts">
import type { SemanticQuery } from '@empathyco/x-components/semantic-queries'
import { ArrowRightIcon, use$x, useState } from '@empathyco/x-components'
import { QueryPreviewList } from '@empathyco/x-components/queries-preview'
import { SemanticQueries } from '@empathyco/x-components/semantic-queries'
import CustomSlidingPanel from '../custom-sliding-panel.vue'
import Result from '../results/result.vue'
import DisplayClickProvider from './display-click-provider.vue'

const { config: semanticQueriesConfig } = useState('semanticQueries')

const resultsPerCarousel = semanticQueriesConfig.value.maxItemsToRequest
const x = use$x()
</script>
